interface TravelTargetBarProps {
  targetName: string;
  onClear: () => void;
}

export function TravelTargetBar({ targetName, onClear }: TravelTargetBarProps) {
  return (
    <div
      className="absolute top-2 left-1/2 -translate-x-1/2 z-10 glass px-3 py-2 rounded-xl flex items-center gap-2 shadow-card"
      style={{ transform: 'translateX(-50%)' }}
    >
      <span className="text-stardust">🧭</span>
      <span className="text-xs text-white/80">
        Цель: <span className="text-white font-medium">{targetName}</span>
      </span>
      <button
        onClick={onClear}
        className="text-white/40 hover:text-white text-base leading-none w-5 h-5 inline-flex items-center justify-center ml-1"
        aria-label="Clear target"
      >
        ×
      </button>
    </div>
  );
}
